'use strict';

import videojs from 'video.js'
import _ from "lodash";

let Component = videojs.getComponent('Component');

class OverlayBanner extends Component {

    constructor(player, options) {
        super(player, options);
        this.overlayTime = options.overlayTime;
        this.elementId = options.elementId;
        this.hide();
    }

    createEl() {
        let el = super.createEl('div');
        el.appendChild(document.getElementById(this.options().elementId).childNodes[0]);
        return el;
    }

}

videojs.registerComponent('OverlayBanner', OverlayBanner);